import { deepCopyJson, iFrameLauncherEvent } from "@classdojo/monsterverse-utils";

import { LoadingProgress } from "./LoadingProgress";
import { PCAppEventHandler } from "./PCAppEventHandler";

let pcAppEventHandler: PCAppEventHandler | undefined;
export let loadingProgress: LoadingProgress;

export function postToApp(evt: { eventName: string; eventValues?: unknown[] }) {
  if (window.parent !== window) {
    const data = {
      eventName: evt.eventName,
      eventValues: evt.eventValues && deepCopyJson(evt.eventValues),
    };
    try {
      window.parent.postMessage(data, "*");
    } catch (err) {
      const msg = JSON.stringify({ data });
      throw new AggregateError([err], `postMessage failed: launcher MessageHandler.postToApp: ${msg}`);
    }
  }
  pcAppEventHandler?.post(evt);
}

export function handleIFrameMessages(iframeEl: HTMLIFrameElement, loadingEl: HTMLElement) {
  pcAppEventHandler = new PCAppEventHandler(iframeEl);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).pc = {
    app: pcAppEventHandler,
  };

  loadingProgress = new LoadingProgress(loadingEl, pcAppEventHandler);

  window.addEventListener("message", (ev) => {
    if (ev?.data?.iFrameLauncherEvent !== iFrameLauncherEvent) {
      //Repost upwards or downwards to allow app handshake to work
      if (ev.source === iframeEl.contentWindow) {
        postToApp(ev.data);
      } else {
        try {
          iframeEl.contentWindow?.postMessage(ev.data, "*");
        } catch (err) {
          const msg = JSON.stringify({ data: ev?.data });
          throw new AggregateError([err], `postMessage failed: launcher MessageHandler.handleIFrameMessages: ${msg}`);
        }
      }
    }
  });
  return pcAppEventHandler;
}
